'use strict';

import React from 'react';
import PropTypes from "prop-types";
import {isEmpty as underscoreIsEmpty} from 'underscore';
import classnames from 'classnames';
import moment from "moment";

import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

import appStore from "@uw-it-sis/lib-react/lib/AppStore";
import {daysOfWeekAbbreviation} from "./CourseUtils";
import {isEmpty} from '@uw-it-sis/lib-react/lib/Utils';

/**
 * Creates a list of rows of section (activity) data from a list of meeting details
 * @param props contains meetings list, and which campus the section resides
 * @return list of rows of section data
 */
const SectionMeetingDetails = ({meetings, mode = "In-person", campus}) => {
    let meeting;
    let isCourseApp = appStore.getAppContext().toLowerCase() === "course";
    let tba = isCourseApp ? "To be arranged" : "Meeting time and location: --";

    let meetingMode = <div className="my-2 my-sm-0"><span className="sr-only">Learning Format </span><span>{mode}</span></div>;
    // If there are meeting items in the list
    if (meetings.length > 0) {
        let meetingDetails = meetings.map(function (offering, offeringIndex) {
            // If days and time are empty, its TBA
            let daysAndTimesEmpty = true;
            [offering.days, offering.time].forEach(test => {
                if ( daysAndTimesEmpty && ! (isEmpty(test) || underscoreIsEmpty(test.trim())) ) {
                    daysAndTimesEmpty = false;
                }
            });

            if ( daysAndTimesEmpty ) {
                return (
                    <Row className="my-2 my-sm-0 g-0" key={offeringIndex}>
                        <Col>
                            <span className="sr-only">Meeting time and location to be arranged</span>
                            <span aria-hidden={true}>{tba}</span>
                        </Col>
                    </Row>
                );

            } else {
                let location;
                    if (offering.building) {
                        // If building is not NOC (Not On Campus), doesn't starts with '*', and is seattle campus, and the app is 'course', then create link to campus map
                        if (
                            offering.building !== 'NOC' &&
                            offering.building.indexOf('*') !== 0 &&
                            campus !== null &&
                            campus.toLowerCase() === 'seattle' &&
                            isCourseApp
                        ) {
                            location =
                                <>
                                    <a href={'http://uw.edu/maps/?' + offering.building.toLowerCase()} target="_blank">{offering.building}</a> <span className="sr-only">building room</span> {offering.room}
                                </>;
                        } else {
                            location =
                                <>
                                    {offering.building} <span className="sr-only"> building room </span> {offering.room}
                                </>;
                        }
                    }

                let time = offering.time;
                if ( /\d{1,2}:\d{2}\s[apmAPM]{2}\s\W\s\d{1,2}:\d{2}\s[apmAPM]{2}/.test(time) ) {
                    let times = time.split(" - ");
                    time =
                        <>
                            <time dateTime={moment(times[0], "h:mm A").format("HH:mm")}>{times[0]}</time>
                            <span aria-hidden={true}> - </span>
                            <span className="sr-only"> to </span>
                            <time dateTime={moment(times[1], "h:mm A").format("HH:mm")}>{times[1]}</time>
                        </>
                }

                return (
                    <div className="d-sm-flex justify-content-sm-between my-2 my-sm-0" key={offeringIndex}>
                        <div className="d-inline-block me-2 me-sm-0">{daysOfWeekAbbreviation(offering.days)}</div>
                        <div className="d-inline-block">{time}</div>
                        <div className="d-block">{location}</div>
                    </div>
                );
            }
        });

        meeting =
            <div>
                {meetingMode}
                {meetingDetails}
            </div>;
    } else {
        meeting = <div>{tba}</div>;
    }

    return meeting;
};

SectionMeetingDetails.propTypes = {
    meetings: PropTypes.array.isRequired,
    mode: PropTypes.string.isRequired,
    campus: PropTypes.string.isRequired
};

export default SectionMeetingDetails;
